export const addresses = {
  snowAddress: "0x6345e50859b0Ce82D8A495ba9894C6C81de385F3",
  snowArtAddress: "0x88D1aF96098a928eE278f162c1a84f339652f95b",
};
